module.exports = __webpack_public_path__ + "img/bjdx.29553205.svg";